import { SelectedOptionsButton } from './components/SelectedOptionsButton';
import { SectionsSwitcher } from './components/SectionsSwitcher';
import React from 'react';
import style from './SubcategoriesControlPanel.module.scss';

export const SubcategoriesControlPanel: React.FC = () => {
	return (
		<div className={style.container} data-test="SubcategoriesControlPanel">
			<SectionsSwitcher />
			<SelectedOptionsButton />
		</div>
	);
};
